import { Box, CircularProgress } from "@mui/material";
import { EMPTY_SX } from "../../utils/empty-sx";

import type { CommsImageLoaderState } from "./generate-comms-context";
import type { BoxProps } from "@mui/material";
import type { FC } from "react";

export const CommsTemplateCarouselImage: FC<
  BoxProps & { selected?: boolean; image?: CommsImageLoaderState }
> = ({ image, selected = false, sx = EMPTY_SX, ...props }) => (
  <Box
    data-analytics-id="template-carousel-image"
    role="button"
    {...props}
    sx={[
      {
        boxShadow: 2,
      },
      (theme) => ({
        boxSizing: "content-box",
        borderStyle: "solid",
        borderWidth: 2,
        borderColor: selected ? theme.palette.primary.main : "divider",
        cursor: props.onClick ? "pointer" : "default",
        backgroundImage:
          image && !image?.loading && image.data?.url ? `url(${image.data.url})` : "none",
        backgroundSize: "cover",
        position: "relative",
        "&:hover": {
          borderColor: theme.palette.primary.main,
        },
        borderRadius: "8px",
      }),
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {(!image || image?.loading || !image.data) && (
      <Box
        style={{
          display: "flex",
          marginTop: "8px",
          marginLeft: "8px",
        }}
      >
        <CircularProgress sx={{ width: "24px", height: "24px" }} />
      </Box>
    )}
  </Box>
);
